import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_17.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/practices');
  const shareText = encodeURIComponent('Workplace Best Practices: Building a Culture That Drives Success!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Best Practices — Outstanding Workplaces</title>
        <meta property="og:title" content="Best Practices — Outstanding Workplaces" />
        <meta property="og:description" content="Workplace Best Practices: Building a Culture That Drives Success" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778051012/i_17_v9zhxc.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/practices" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Best Practices  — Outstanding Workplaces" />
        <meta name="twitter:description" content="Workplace Best Practices: Building a Culture That Drives Success" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778051012/i_17_v9zhxc.jpg" />
      </Helmet>

          <div className="sight_17_page_wrapper">
        <div className="sight_17_content_container">

          <div className="sight_17_section_one">

            <h1 className="sight_17_page_title">
              Workplace Best Practices: Building a Culture That Drives Success
            </h1>

            <div className="sight_17_row">

              <div className="sight_17_left">
                <div className="sight_17_image_wrapper">
                  <img src="/assets/i_17.jpg" alt="Team meeting discussion" className="sight_17_blog_image" />
                </div>


                {/* SHARE SECTION */}
                <div className="sight_17_share_section">
                  <span className="sight_17_share_text">Share :</span>
                  <div className="sight_17_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_17_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_17_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_17_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_17_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_17_para_wrapper">

  <h2 className="sight_17_para_title">
    Why Workplace Best Practices Matter
  </h2>

  <p className="sight_17_para_intro">
    Strong workplace practices help organizations:
  </p>

  <ul className="sight_17_para_list">
    <li>Improve employee engagement and retention</li>
    <li>Enhance productivity and performance</li>
    <li>Foster innovation and collaboration</li>
    <li>Build a positive employer brand</li>
  </ul>

  <p className="sight_17_para_footer">
    When employees feel supported and valued, they contribute more meaningfully to organizational success.
  </p>

</div>


            </div>

              <div className="sight_17_right">
                <div className="sight_17_ad_card">
                  <img src="/assets/bc_1.png" className="sight_17_ad_bg" />
                  <div className="sight_17_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_17_ad_badge" />

                  <div className="sight_17_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>

                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>

                    <button
                      className="sight_17_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>

    <div className="sight_17_section">
      <div className="sight_17_topics">

        <h2 className="sight_17_main_title">
          10 Workplace Best Practices Every Organization Should Adopt
        </h2>

        {/* 1 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">1. Foster Open Communication</h3>
          <ul className="sight_17_topic_list">
            <li>
             Transparent and honest communication builds trust across all levels of the organization. Encourage employees to share ideas, feedback, and concerns without fear.
            </li>
            <li>
              <strong>Tip:</strong> Regular town halls, feedback sessions, and open-door policies can make a big difference.
            </li>
          </ul>
        </div>

        {/* 2 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">2. Prioritize Employee Well-Being</h3>
          <ul className="sight_17_topic_list">
            <li>
              A healthy workforce is a productive workforce. Supporting mental, physical, and emotional well-being should be a top priority.
            </li>
            <li>
              <strong>Examples:</strong> Wellness programs, mental health support, and flexible schedules.
            </li>
          </ul>
        </div>

        {/* 3 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">3. Encourage Work-Life Balance</h3>
          <ul className="sight_17_topic_list">
            <li>
              Promoting balance helps reduce burnout and keeps employees motivated.
            </li>
            <li>
              <strong>Practice:</strong> Flexible work hours, remote work options, and respecting personal time.
            </li>
          </ul>
        </div>

        {/* 4 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">4. Recognize and Reward Contributions</h3>
          <ul className="sight_17_topic_list">
            <li>
              Recognition is a powerful driver of motivation. Employees who feel appreciated are more engaged and committed.
            </li>
            <li>
              <strong>Examples:</strong> Employee of the month, spot awards, peer recognition programs.
            </li>
          </ul>
        </div>

        {/* 5 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">5. Invest in Learning & Development</h3>
          <ul className="sight_17_topic_list">
            <li>
              Continuous learning keeps employees skilled, confident, and future-ready.
            </li>
            <li>
              <strong>Practice:</strong> Training programs, mentorship, leadership development initiatives.
            </li>
          </ul>
        </div>

        {/* 6 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">6. Promote Inclusive & Diverse Culture</h3>
          <ul className="sight_17_topic_list">
            <li>
              Diversity and inclusion create a workplace where everyone feels respected and empowered.
            </li>
            <li>
              <strong>Tip:</strong> Implement unbiased hiring practices and inclusive policies.
            </li>
          </ul>
        </div>

        {/* 7 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">7. Set Clear Goals and Expectations</h3>
          <ul className="sight_17_topic_list">
            <li>
              Clarity in roles and expectations helps employees stay aligned with organizational objectives.
            </li>
            <li>
              <strong>Practice:</strong> Use OKRs or performance frameworks to track progress.
            </li>
          </ul>
        </div>

        {/* 8 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">8. Empower Employees with Autonomy</h3>
          <ul className="sight_17_topic_list">
            <li>
              Micromanagement reduces motivation, Trust employees to take ownership of their work.
            </li>
            <li>
              <strong>Impact:</strong> Encourages innovation, accountability, and confidence.
            </li>
          </ul>
        </div>

        {/* 9 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">9. Build Strong Leadership</h3>
          <ul className="sight_17_topic_list">
            <li>
              Leaders play a critical role in shaping workplace culture, Effective leaders inspire, guide, and support their teams.
            </li>
            <li>
              <strong>Tip:</strong> Invest in leadership training and emotional intelligence development.
            </li>
          </ul>
        </div>

        {/* 10 */}
        <div className="sight_17_topic_item">
          <h3 className="sight_17_topic_heading">10. Leverage Technology for Efficiency</h3>
          <ul className="sight_17_topic_list">
            <li>
              Using the right tools can streamline workflows and improve collaboration.
            </li>
            <li>
              <strong>Examples:</strong> HR tech platforms, communication tools, and performance management systems.
            </li>
          </ul>
        </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;

